import { Component, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import screenfull from 'screenfull';
import { ApplicationStateService } from '../../../services/application-state.service';
import { AssetService } from '../../../services/asset.service';
import { Logger } from '../../../utils/development/logger';
import { ToggleButtonComponent } from './toggle-button/toggle-button.component';

@Component({
    selector: 'app-viewmode-switcher',
    templateUrl: './viewmode-switcher.component.html',
    styleUrls: ['./viewmode-switcher.component.scss'],
    standalone: true,
    imports: [
        ToggleButtonComponent
    ]
})
export class ViewmodeSwitcherComponent implements OnInit {

    show: boolean;
    isIE: boolean;
    isFirefox: boolean;
    isMicrosoftEdge: boolean;
    isScrollMode = false;

    constructor(private applicationStateService: ApplicationStateService,
                private deviceService: DeviceDetectorService,
                public assetService: AssetService) {
    }

    ngOnInit(): void {
        this.show = !(this.deviceService.device() === 'ipad' ||
            this.deviceService.device() === 'iphone' ||
            this.deviceService.device() === 'android' ||
            this.deviceService.isMobile() ||
            this.deviceService.isTablet()
        );
        Logger.log(this.deviceService.getDeviceInfo());
        this.isIE = this.deviceService.browser() === 'ie';
        this.isMicrosoftEdge = this.deviceService.browser() === 'ms-edge';
        this.isFirefox = this.deviceService.getDeviceInfo().browser === 'firefox';
    }

    changeViewMode(viewModeSlug: string): void {

        if (screenfull.isEnabled) {

            if (!(screenfull.isFullscreen)) {
                this.applicationStateService.beforeViewModeChangeSize = $('.bookviewer-page').width();
            }

            screenfull.toggle();

            setTimeout(() => {
                if (screenfull.isEnabled && !(screenfull.isFullscreen)) {
                    this.applicationStateService.beforeViewModeChangeSize = 0;
                }
            }, 250);
        }
    }
}
